import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

interface CategoryCardProps {
  category: {
    id: string;
    title: string;
    description: string;
    image: string;
    link: string;
    subcategories?: string[];
  };
}

const CategoryCard: React.FC<CategoryCardProps> = ({ category }) => {
  return (
    <Link
      key={category.id}
      to={category.link}
      className="group bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-300"
    >
      <div className="h-48 overflow-hidden">
        <img
          src={category.image}
          alt={category.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
          width="341"
          height="192"
        />
      </div>
      <div className="p-6">
        <h2 className="text-xl font-semibold mb-2 group-hover:text-primary-600 transition-colors">
          {category.title}
        </h2>
        <p className="text-gray-600 mb-4">{category.description}</p>
        {category.subcategories && category.subcategories.length > 0 && (
          <div className="space-y-2 mb-6">
            {category.subcategories.map((sub, index) => (
              <div key={index} className="flex items-center text-sm text-gray-500">
                <div className="w-1.5 h-1.5 bg-primary-500 rounded-full mr-2"></div>
                {sub}
              </div>
            ))}
          </div>
        )}
        <div className="inline-flex items-center font-medium text-primary-600 group-hover:text-primary-700">
          Подробнее
          <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
        </div>
      </div>
    </Link>
  );
};

export default CategoryCard;
